module.exports = __webpack_public_path__ + "img/sylc_title.853bc612.png";